(function () {
  function push(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  function handleFromUrl(url) {
    const match = String(url || "").match(/\/products\/([a-z0-9-_]+)/i);
    return match ? match[1] : "";
  }

  // Capture phase so tracking fires before the CTA handlers, which may stop
  // propagation (quick-add popup open, notify subscribe).
  document.addEventListener(
    "click",
    function (event) {
      // Waitlist CTA on product cards (PLP grid, home carousels)
      const cardCta = event.target.closest(".card-product__button--notify");
      if (cardCta) {
        if (cardCta.classList.contains("disabled")) return;

        push({
          event: "notify_me_click",
          notify_source: "product_card",
          product_handle: handleFromUrl(cardCta.dataset.productUrl),
          page_path: window.location.pathname,
        });
        return;
      }

      // notify-me buttons: PDP, quick view popup, home hero block
      const notifyButton = event.target.closest(
        "notify-me [data-notify-button]",
      );
      if (!notifyButton || notifyButton.disabled) return;

      const element = notifyButton.closest("notify-me");

      let source = "pdp";
      if (notifyButton.closest(".button-notify")) {
        source = "home_hero";
      } else if (notifyButton.closest(".quick-add")) {
        source = "plp_popup";
      }

      push({
        event: "notify_me_click",
        notify_source: source,
        product_handle: (element && element.dataset.productHandle) || "",
        page_path: window.location.pathname,
      });
    },
    true,
  );
})();